import clsx from "clsx";
import React from "react";
import { createProfilePageURL } from "#lib/urls";
import { IApprovedDM } from "#entities/dms";
import { paysites } from "#entities/paysites";
import { ImageViewer } from "#components/image-viewer";
import { FancyLink } from "../links";
import { Creator } from "#api/creators";
import { Timestamp } from "#components/dates";

import * as styles from "./dm.module.scss"

interface IProps {
  dm: IApprovedDM;
  creator: Creator;
  isPrivate?: boolean;
  isGlobal?: boolean;
  className?: string;
}

export function DMCard({
  dm,
  isGlobal = false,
  isPrivate = false,
  creator,
  className,
}: IProps) {
  const { service, user } = dm;
  const paysite = paysites[service];
  const profilePageURL = String(
    createProfilePageURL({ service, creatorId: user })
  );
  const remoteProfilePageURL = paysite.user.profile(creator);

  return (
    <article
      className={clsx("dm-card", className)}
      data-id={!isPrivate ? undefined : dm.hash}
      style={{"--card-size": dm.file.length ? "550px" : undefined} as React.CSSProperties}
    >
      {!isGlobal ? undefined : (
        <header className="dm-card-header">
          <FancyLink url={profilePageURL} className="dms__user-link">
            <span className="dm-card__user">{creator.name}</span>
          </FancyLink>
          <FancyLink
            url={remoteProfilePageURL}
            className="dms__remote-user-link"
            isNoop
          >
            <span className="dm-card__service">({paysite.title})</span>
          </FancyLink>
        </header>
      )}

      {!isPrivate ? undefined : (
        <header className="dm-card-header">
          <FancyLink url={profilePageURL} className="dms__user-link">
            <span className="dm-card__user">{creator.name}</span>
          </FancyLink>
          <FancyLink
            url={remoteProfilePageURL}
            className="dms__remote-user-link"
            isNoop
          >
            <span className="dm-card__service">({paysite.title})</span>
          </FancyLink>
        </header>
      )}

      <section className="dm-card__body" tabIndex={0}>
        <div className="dm-card__content">
          <pre className={styles.content}>{dm.content}</pre>
        </div>
      </section>

      {dm.file?.length ? (
        <section className="dm-card__attachments">
          <ImageViewer images={dm.file} className={styles.imageViewer} />
        </section>
      ) : undefined}

      <footer className="dm-card__footer">
        <div className="dm-card__added">
          {dm.published ? "Published:" : "Added:"} <Timestamp time={dm.published || dm.added} />
        </div>
      </footer>
    </article>
  );
}
